import React from 'react'

import cn from 'classnames'

import ChainToken from '@src/components/ChainToken'
import { getChainNameFromChainId } from '@src/configs/chainInfo'
import { IToken } from '@src/types/token'
import { formatNumber } from '@src/utils/formatFee'

interface CompactTokensListItemProps {
    selectedToken?: IToken
    token: IToken
    onTokenClicked: (token: IToken) => void
    userBalanceInTokens?: string
    userBalanceInUsd?: string
}

export const CompactTokensListItem: React.FC<CompactTokensListItemProps> = ({
    selectedToken,
    token,
    onTokenClicked,
    userBalanceInTokens,
    userBalanceInUsd,
}) => {
    const isSelected = token.address === selectedToken?.address && token.chainId === selectedToken?.chainId

    return (
        <button
            className={cn(
                'flex w-full items-center gap-3 rounded-md px-4 py-3.5 transition-colors duration-200 hover:bg-token-modal-chain-hover',
                isSelected && 'border border-token-modal-border bg-token-modal-chain-selected'
            )}
            onClick={() => onTokenClicked(token)}
        >
            <ChainToken
                tokenLogo={token.name === 'BitTorrent' ? '/assets/token/btt.png' : token.logoURI}
                networkIcon={`/assets/network/${getChainNameFromChainId(token.chainId)}.png`}
                tokenIconSize={28}
                chainIconSize={14}
            />
            <div className='flex flex-1 flex-col items-start gap-0.5 overflow-hidden'>
                <span className='text-left text-[14px] font-bold'>{token.symbol}</span>
                <span className='overflow-hidden text-ellipsis text-left text-xs text-token-modal-label-text'>
                    {token.name}
                </span>
            </div>
            <div className='flex items-center gap-2'>
                {userBalanceInTokens && (
                    <div className='flex flex-col items-end'>
                        {userBalanceInUsd && (
                            <span className='text-[14px] font-medium'>
                                {userBalanceInUsd.startsWith('<')
                                    ? userBalanceInUsd
                                    : `$${formatNumber(userBalanceInUsd)}`}
                            </span>
                        )}
                        <span className='text-xs text-token-modal-label-text'>{userBalanceInTokens}</span>
                    </div>
                )}
                {isSelected && <div className='h-2 w-2 shrink-0 rounded-full bg-token-modal-accent-blue' />}
            </div>
        </button>
    )
}

export default CompactTokensListItem
